import { UPDATE_SUBMISSION_PROGRESS_STAGE } from 'actions/submissionProgress'

export default (state = null, action) => {
    switch (action.type) {
        case UPDATE_SUBMISSION_PROGRESS_STAGE:
            return Object.assign({}, state, {stage: action.payload});
    }

    return state;
}